import axios from '../axios';

const path = '/api/dummy';
export default {
  dummy() {
    return axios.get(path);
  },
};
